import { render, staticRenderFns } from "./Lang1Age1.vue?vue&type=template&id=30dd9574&scoped=true&"
import script from "./Lang1Age1.vue?vue&type=script&lang=js&"
export * from "./Lang1Age1.vue?vue&type=script&lang=js&"
import style0 from "./Lang1Age1.vue?vue&type=style&index=0&id=30dd9574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dd9574",
  null
  
)

export default component.exports